import React from 'react';
import {Icons} from '../../util/icons';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  name: Icons;
  color?: string;
  width?: string;
  height?: string;
  strokeWidth?: string;
  changeViewbox?: boolean;
  viewBox?: any;
  transform?: string;
}

function Icon({
  name,
  color,
  width = '24',
  height = '24',
  strokeWidth = '0',
  changeViewbox = true,
  viewBox = null,
  transform = '',
  ...rest
}: IconProps) {
  return (
    <svg
      width={`${width}px`}
      height={`${height}px`}
      fill={color || 'currentColor'}
      viewBox={
        viewBox
          ? viewBox
          : `0 0 ${changeViewbox ? width : 0} ${changeViewbox ? height : 0}`
      }
      fontWeight="6000"
      {...rest}>
      <path
        stroke={color || 'currentColor'}
        strokeWidth={strokeWidth}
        d={name}
        transform={transform}
      />
    </svg>
  );
}

export default Icon;
